export default "__VITE_ASSET__CdeiYLyp__"